/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountIlsCounts } from '../../models/account-ils-counts';

export interface FolderControllerGetUserIlsCounts$Params {
  accountId: string;
}

export function folderControllerGetUserIlsCounts(http: HttpClient, rootUrl: string, params: FolderControllerGetUserIlsCounts$Params, context?: HttpContext): Observable<StrictHttpResponse<AccountIlsCounts>> {
  const rb = new RequestBuilder(rootUrl, folderControllerGetUserIlsCounts.PATH, 'get');
  if (params) {
    rb.path('accountId', params.accountId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccountIlsCounts>;
    })
  );
}

folderControllerGetUserIlsCounts.PATH = '/folder/ilsCount/{accountId}';
